import { useTranslation } from 'react-i18next'
import { HeroPage } from '@/components/HeroPage'
import { Section } from '@/components/ui/Section'
import { Container } from '@/components/ui/Container'

export function Privacy() {
  const { t } = useTranslation()

  const dataProcessingItems = [
    t('privacy.dataProcessing.items.contact'),
    t('privacy.dataProcessing.items.careers'),
    t('privacy.dataProcessing.items.quotes'),
    t('privacy.dataProcessing.items.analytics'),
  ]

  return (
    <main>
      <HeroPage
        title={t('footer.privacy')}
        breadcrumb={[{ label: t('footer.privacy') }]}
      />
      <Section>
        <Container>
          <div className="prose max-w-none">
            <h2 className="text-2xl font-bold text-dark mb-4">
              {t('privacy.title')}
            </h2>
            <p className="text-gray-600 mb-4">
              {t('privacy.intro')}
            </p>

            <h3 className="text-xl font-semibold text-dark mb-3 mt-6">
              {t('privacy.controller.title')}
            </h3>
            <p className="text-gray-600 mb-4">
              {t('privacy.controller.text')}
            </p>

            <h3 className="text-xl font-semibold text-dark mb-3 mt-6">
              {t('privacy.dataProcessing.title')}
            </h3>
            <p className="text-gray-600 mb-4">
              {t('privacy.dataProcessing.text')}
            </p>
            <ul className="list-disc pl-6 text-gray-600 mb-4 space-y-2">
              {dataProcessingItems.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>

            <h3 className="text-xl font-semibold text-dark mb-3 mt-6">
              {t('privacy.legalBasis.title')}
            </h3>
            <p className="text-gray-600 mb-4">
              {t('privacy.legalBasis.text')}
            </p>

            <h3 className="text-xl font-semibold text-dark mb-3 mt-6">
              {t('privacy.rights.title')}
            </h3>
            <p className="text-gray-600 mb-4">
              {t('privacy.rights.text')}
            </p>

            <h3 className="text-xl font-semibold text-dark mb-3 mt-6">
              {t('privacy.retention.title')}
            </h3>
            <p className="text-gray-600 mb-4">
              {t('privacy.retention.text')}
            </p>
          </div>
        </Container>
      </Section>
    </main>
  )
}
